var exports = {
  "Y9": "Header__ZjC39w",
  "y_": "Count__HYhgPN",
  "Cu": "Filters__Xx2za5",
  "EY": "Text__uC0cG0",
  "fI": "Row__ZUfQX6",
  "B_": "Details__1VB_hC",
  "VY": "Description__R5WtHF",
  "lg": "Branch__uhenyk",
  "i6": "LastUsed__0Nfj8-",
  "En": "Actions__2-jJsj",
  "oS": "Ref__sCRsk2",
};

module.exports = exports;
